import { render, staticRenderFns } from "./investment-real-estate-add-popup.vue?vue&type=template&id=740a4126&lang=true&"
import script from "./investment-real-estate-add-popup.vue?vue&type=script&lang=ts&"
export * from "./investment-real-estate-add-popup.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports